import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/home/home'
import FloorPlans from '@/pages/floor-plans/floor-plans'
import Amenities from '@/pages/amenities/amenities'
import Photos from '@/pages/photos/photos'
import Neighborhood from '@/pages/neighborhood/neighborhood'
import Contact from '@/pages/contact/contact'
import Maintenance from '@/pages/maintenance/maintenance'
import Specials from '@/pages/specials/specials'
import ThankYou from '@/pages/thank-you/thank-you'
import Sitemap from '@/pages/sitemap/sitemap'
import Accessibility from '@/pages/accessibility/accessibility'
// import PageNotFound from '@/pages/404/404'
import scrollBehavior from '@/shared/functionality/scroll-behavior'
import Styleguide from '@/styleguide/styleguide'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      navigation: true,
      component: Home
    },
    {
      path: '/floor-plans',
      name: 'Floor Plans',
      navigation: true,
      component: FloorPlans
    },
    {
      path: '/amenities',
      name: 'Amenities',
      navigation: true,
      component: Amenities
    },
    {
      path: '/photos',
      name: 'Photos',
      navigation: true,
      component: Photos
    },
    {
      path: '/neighborhood',
      name: 'Neighborhood',
      navigation: true,
      component: Neighborhood
    },
    {
      path: '/contact',
      name: 'Contact',
      navigation: true,
      component: Contact
    },
    {
      path: '/maintenance',
      name: 'Maintenance',
      navigation: true,
      component: Maintenance
    },
    {
      path: '/specials',
      name: 'Specials',
      navigation: false,
      component: Specials
    },
    {
      path: '/thank-you',
      name: 'Thank You',
      navigation: true,
      component: ThankYou
    },
    {
      path: '/sitemap',
      name: 'Sitemap',
      navigation: true,
      component: Sitemap
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      navigation: false,
      component: Accessibility
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      navigation: false,
      component: Styleguide
    },
    {
      path: '/*',
      name: 'page-not-found',
      navigation: false,
      component: Home
    }
  ],
  scrollBehavior
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js